import { useState, useEffect, useCallback, useRef } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Switch from "@mui/material/Switch";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import { Typography } from "@mui/material";
import styles from "./subscriptions.module.css";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import { TablePagination } from "@mui/material";
import { TableRow } from "@mui/material";
import { TableCell } from "@mui/material";
import { useLocalStorage } from "@uidotdev/usehooks";
import isDesktop from "../isDesktop";
import SubscriptionsMobile from "./SubscriptionsMobile";
import { ArrowBackIosNewRounded } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { hasStoredTabAccess } from '../utils/access';

const Subscriptions = () => {
  const isDesktopDevice = isDesktop();
  const navigate=useNavigate()
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [openSpecDialog, setOpenSpecDialog] = useState(false);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [selectedSpecs, setSelectedSpecs] = useState([]);
  const [changedSkills, setChangedSkills] = useState([]);
  const [filteredSkills, setFilteredSkills] = useState([]);
  const [filteredSpecs, setFilteredSpecs] = useState([]);
  const [specSearchQuery, setSpecSearchQuery] = useState("");
  const [specLoading, setSpecLoading] = useState(false);
  const [specError, setSpecError] = useState("");
  const latestSpecFetchId = useRef(0);
  const [selectedUser, setSelectedUser] = useState({});
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [actionType, setActionType] = useState("skills");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedDays, setSelectedDays] = useState(7);
  // eslint-disable-next-line no-unused-vars
  const [token, setToken] = useLocalStorage("token", null);
  const [skillsCompletion, setSkillsCompletion] = useState([]);
  const isAuthorized = hasStoredTabAccess('Subscriptions');
  const canUpdateUser = isAuthorized;
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [updateDialog, setUpdateDialog] = useState(false);
  const [openEditDateDialog, setOpenEditDateDialog] = useState(false);
  const [editTargetSpecId, setEditTargetSpecId] = useState(null);
  const [editMode, setEditMode] = useState("ADD_DAYS");
  const [editDays, setEditDays] = useState("");
  const [editTargetDate, setEditTargetDate] = useState("");
  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const displayedUsers = filteredUsers.slice(startIndex, endIndex);
  const emptyRows =
    rowsPerPage -
    Math.min(rowsPerPage, filteredUsers.length - page * rowsPerPage);

  const [formValues, setFormValues] = useState({
    name: "",
    email: "",
    mobile: "",
    referredBy:"",
    subscription_type: "free",
    communicationLanguage: "hi",
  });

  const handleUpdate = async (userId) => {
    if (!canUpdateUser) return;

    const selected = users.find((user) => user.user_id === userId);
    console.log(selected,"selected");
    console.log(selected.referred_id);

    setSelectedUser(selected);

    let communicationLanguage = "hi";
    try {
      const prefResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/user-preferences/${userId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      communicationLanguage = prefResponse.data?.communicationLanguage || "hi";
    } catch (error) {
      console.error("Error fetching user preferences:", error);
    }

    setFormValues({
      id: selected.user_id,
      name: selected.name,
      email: selected.email,
      mobile: selected.mobile,
      referredBy:selected.referred_id,
      subscription_type: selected.subscription_type || "free",
      communicationLanguage,
    });
    setUpdateDialog(true);
  };

  const handleUpdateDialogClose = () => {
    setUpdateDialog(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({ ...prevValues, [name]: value }));
  };
  console.log(formValues.referredBy);
  
  const handleUpdateUser = async (id) => {
    if (!canUpdateUser) return;

    const { name, email, mobile, referredBy, subscription_type, communicationLanguage } = formValues;
    console.log(formValues);

    if (!name || !email || !mobile) {
      console.error("All fields are required");
      return;
    }

    const validSubscriptionTypes = ["free", "paid"];
    if (!validSubscriptionTypes.includes(subscription_type)) {
      toast.error("Invalid subscription type");
      return;
    }

    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/updateUser/update/${id}`,
        {
          name,
          email,
          mobile,
          referredBy,
          subscription_type,
          communication_language: communicationLanguage,
        },
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        toast.success("User data updated successfully");
        fetchUsers();
        setUpdateDialog(false);
      } else {
        toast.error("Error updating user data: ", response.data.message);
      }
    } catch (error) {
      toast.error("Error updating user data: ", error);
    }
  };

  const fetchUsers = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/user/all?order=desc`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        const reversedUsers = response.data.data.reverse(); // Reverse the array of users
        setUsers(reversedUsers);
        setFilteredUsers(reversedUsers); // Initially set filtered users to all users
      } else {
        console.error("Error fetching users: ", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching users: ", error);
    }
  };

  const fetchCompletionData = async (userId, token) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/user/${userId}/skillCompletion`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data; // Return the completion data
    } catch (error) {
      console.error("Error fetching skills completion data: ", error);
      return null; // Return null in case of error
    }
  };

  useEffect(() => {
    if (isDesktopDevice) {
      fetchUsers();
      fetchCompletionData(token);
    }
  }, [token]);

  // Function to handle opening the dialog and fetching completion data
  const handleOpenDialog = async (userId, action) => {
    try {
      // await fetchSkills(); // Fetch skills first

      if (action === "skills") {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/subscription/skill-data/${userId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log(response.data.data);
        const fetchedSkills = response.data.data;
        const sSkills = fetchedSkills.map((val) =>
          val.is_active === null ? false : val.is_active === 0 ? false : true
        );
        console.log(sSkills);
        const selected = users.find((user) => user.user_id === userId);

        setSelectedUser(selected);
        setSelectedSkills(sSkills);
        setFilteredSkills(fetchedSkills);
        const completionData = await fetchCompletionData(userId, token);

        console.log(completionData !== null || completionData.length !== 0);
        if (completionData !== null) {
          // If completion data is fetched successfully
          setSkillsCompletion(completionData); // Update the state with completion data

          setOpenDialog(true);
        } else {
          // If completion data fetch fails, display an error message or handle gracefully
          throw new Error("Failed to fetch skills completion data.");
        }
      } else if (action === "specs") {
        setSpecSearchQuery("");
        setSpecError("");
        setSpecLoading(true);
        setFilteredSpecs([]);
        setSelectedSpecs([]);
        setOpenSpecDialog(true);
      }
      setSelectedUserId(userId);
      // setSelectedSkills(userSkills);
      setActionType(action);

      // const completionData = await fetchCompletionData(userId, token); // Fetch completion data
      // console.log(completionData);
    } catch (error) {
      console.error(
        "Error opening dialog and fetching completion data: ",
        error
      );
      toast.error(
        "An error occurred while opening the dialog.",
        error.toString()
      );
    }
  };
  console.log(changedSkills);
  const handleUnsubscription = () => {
    if (actionType === "update") {
      updateSkillStatus(changedSkills, 0);
    }
  };

  // useEffect(()=>{
  //   setOpenDialog(true)
  // },[filteredSkills])

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setOpenSpecDialog(false);
    setOpenEditDateDialog(false);
    setSelectedUserId(null);
    setSelectedSkills([]);
    setFilteredSkills([]);
    setFilteredSpecs([]);
    setSpecSearchQuery("");
    setSpecError("");
    setSpecLoading(false);
    latestSpecFetchId.current += 1;
    setSelectedSpecs([]);
    setChangedSkills([]);
    setEditTargetSpecId(null);
    setEditDays("");
    setEditTargetDate("");
  };

  const handleButtonClick = (userId, action) => {
    handleOpenDialog(userId, action);
  };

  const handleResetButtonClick = (userId) => {
    const apiUrl = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/change-password/${userId}/resetLimit`;

    axios
      .put(apiUrl)
      .then((response) => {
        console.log(response.data.message);
        toast.success("User limit has been reset successfully.");
      })
      .catch((error) => {
        console.error("Error occurred: ", error);
        toast.error(
          error.response?.data?.message ||
            "An error occurred. Please try again later."
        );
      });
  };

  const handleSkillToggle = (e, skillId, ind) => {
    console.log(e.target.checked);
    console.log(selectedSkills);

    setSelectedSkills((prevSkills) => {
      const newSkills = [...prevSkills];
      newSkills[ind] = !newSkills[ind];

      return newSkills;
    });
  };

  const handleSpecToggle = (e, skillId, ind) => {
    console.log(e.target.checked);
    console.log(selectedSkills);

    setSelectedSpecs((prevSpecs) => {
      const newSpecs = [...prevSpecs];
      newSpecs[ind] = !newSpecs[ind];

      return newSpecs;
    });
  };

  const refreshSpecData = useCallback(async (userId, searchValue = "") => {
    const fetchId = latestSpecFetchId.current + 1;
    latestSpecFetchId.current = fetchId;
    const trimmedSearch = searchValue.trim();
    const searchQuery = trimmedSearch
      ? `?search=${encodeURIComponent(trimmedSearch)}`
      : "";

    setSpecLoading(true);
    setSpecError("");

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/subscription/spec-data/${userId}${searchQuery}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (fetchId !== latestSpecFetchId.current) {
        return;
      }

      const fetchedSpecs = response.data.data || [];
      const sSpecs = fetchedSpecs.map((val) =>
        val.is_active === null ? false : val.is_active === 0 ? false : true
      );
      setSelectedSpecs(sSpecs);
      setFilteredSpecs(fetchedSpecs);
    } catch (error) {
      if (fetchId !== latestSpecFetchId.current) {
        return;
      }

      console.error("Error fetching specialization subscription data:", error);
      setFilteredSpecs([]);
      setSelectedSpecs([]);
      setSpecError(
        error.response?.data?.message ||
          "Error fetching specialization subscription data"
      );
    } finally {
      if (fetchId === latestSpecFetchId.current) {
        setSpecLoading(false);
      }
    }
  }, [token]);

  useEffect(() => {
    if (!openSpecDialog || actionType !== "specs" || !selectedUserId) {
      return;
    }

    const debounceTimer = setTimeout(() => {
      refreshSpecData(selectedUserId, specSearchQuery);
    }, 300);

    return () => clearTimeout(debounceTimer);
  }, [
    actionType,
    openSpecDialog,
    refreshSpecData,
    selectedUserId,
    specSearchQuery,
  ]);

  const handleOpenEditDate = (specializationId) => {
    setEditTargetSpecId(specializationId);
    setEditMode("ADD_DAYS");
    setEditDays("");
    setEditTargetDate("");
    setOpenEditDateDialog(true);
  };

  const handleCloseEditDate = () => {
    setOpenEditDateDialog(false);
    setEditTargetSpecId(null);
    setEditDays("");
    setEditTargetDate("");
  };

  const handleUpdateSubscriptionEndDate = async () => {
    if (!selectedUserId || !editTargetSpecId) {
      toast.error("User or specialization not selected");
      return;
    }

    if (editMode === "ADD_DAYS") {
      const days = Number(editDays);
      if (!Number.isInteger(days) || days <= 0) {
        toast.error("Days must be a positive integer");
        return;
      }
    }

    if (editMode === "SET_DATE" && !editTargetDate) {
      toast.error("Target date is required");
      return;
    }

    const payload = {
      userId: selectedUserId,
      targetType: "SPECIALIZATION",
      specializationId: editTargetSpecId,
      updateType: editMode,
      ...(editMode === "ADD_DAYS"
        ? { days: Number(editDays) }
        : { targetDate: editTargetDate }),
    };

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/subscription/update-end-date`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success(response?.data?.message || "End date updated successfully");
      await refreshSpecData(selectedUserId, specSearchQuery);
      handleCloseEditDate();
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Error updating subscription end date"
      );
    }
  };

  const updateSkillStatus = (skillId, isActive) => {
    if (skillId.length === 0) {
      toast.error("No skill selected");
      return;
    }
    const data = {
      user_id: selectedUserId,
      skill_id: skillId,
      is_active: isActive,
    };

    axios
      .put(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/enrollment/updateStatus`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        toast.success("User Unsubscribed successfully");
        setOpenDialog(false);
        console.log("Status update success:", response.data);
      })
      .catch((error) => {
        toast.error("Update Failed.");
        console.error("Status update error:", error);
      });
  };

  const handleSubscription = async () => {
    setOpenDialog(false);
    const skillsToInsert = filteredSkills
      .filter((skill, index) => {
        if (skill.is_active === null && selectedSkills[index] === true) {
          return true;
        }
        return false;
      })
      .map((val) => {
        return {
          skillId: val.skill_id,
          isActive: true,
        };
      });

    const skillsToUpdate = filteredSkills
      .map((skill, index) => {
        if (
          skill.is_active !== null &&
          skill.is_active != selectedSkills[index]
        ) {
          return {
            skillId: skill.skill_id,
            isActive: selectedSkills[index],
          };
        }
      })
      .filter((val) => val !== undefined);

    // console.log(skillsToInsert);
    // console.log("Break");
    // console.log(skillsToUpdate);

    if (actionType == "skills") {
      try {
        const response = await axios.put(
          `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/subscription/skill-subscription`,
          {
            skillsToInsert: skillsToInsert || [],
            skillsToUpdate: skillsToUpdate || [],
            userId: selectedUserId,
          }
        );

        if (response.status === 200) {
          toast.success("Skills Updated Successfully");
        }
      } catch (error) {
        toast.error("error Updating skills Status");
        console.error(error);
      }
    }
  };

  const handleSpecSubscription = async () => {
    setOpenSpecDialog(false);
    const specToInsert = filteredSpecs
      .filter((spec, index) => {
        if (spec.is_active === null && selectedSpecs[index] === true) {
          return true;
        }
        return false;
      })
      .map((val) => {
        return {
          specId: val.specialization_id,
          isActive: true,
        };
      });

    const specsToUpdate = filteredSpecs
      .map((spec, index) => {
        if (spec.is_active !== null && spec.is_active != selectedSpecs[index]) {
          return {
            specId: spec.specialization_id,
            isActive: selectedSpecs[index],
          };
        }
      })
      .filter((val) => val !== undefined);

    const finalArray = specToInsert.concat(specsToUpdate);

    if (actionType == "specs") {
      try {
        const response = await axios.put(
          `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/subscription/specialization-subscription`,
          {
            specArray: finalArray,
            durationDays: selectedDays,
            userId: selectedUserId,
          }
        );

        if (response.status === 200) {
          toast.success("Specialization Updated Successfully");
        }
      } catch (error) {
        toast.error("error Updating Specialization Status");
        console.error(error);
      }
    }
  };

  // Function to filter users based on search query
  const filterUsers = (query) => {
    if (!query) {
      setFilteredUsers(users);
    } else {
      const filtered = users.filter(
        (user) =>
          user.name.toLowerCase().includes(query.toLowerCase()) ||
          user.username.toLowerCase().includes(query.toLowerCase()) ||
          user.email.toLowerCase().includes(query.toLowerCase())
      );
      setFilteredUsers(filtered);
    }
  };

  useEffect(() => {
    isDesktopDevice && filterUsers(searchQuery);
  }, [searchQuery]);

  if (!isAuthorized) {
    return (
      <div className="container-fluid mt-5">
        <h2 style={{ marginTop: "5%" }}>
          You are unauthorized to access this page
        </h2>
      </div>
    );
  }

  function formatDate(dateTimeString) {
    const date = new Date(dateTimeString);
    const formattedDate = `${date.getDate().toString().padStart(2, "0")}-${(
      date.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${date.getFullYear()}`;
    const formattedTime = `${date.getHours().toString().padStart(2, "0")}:${date
      .getMinutes()
      .toString()
      .padStart(2, "0")}:${date.getSeconds().toString().padStart(2, "0")}`;
    return `${formattedDate} ${formattedTime}`;
  }

  function formatSkillEndDate(dateTimeString) {
    if (!dateTimeString) {
      return "-";
    }
    const date = new Date(dateTimeString);
    if (Number.isNaN(date.getTime())) {
      return "-";
    }
    const formattedDate = `${date.getDate().toString().padStart(2, "0")}-${(
      date.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${date.getFullYear()}`;
    return formattedDate;
  }

  return (
    <>
      {isDesktopDevice ? (
        <div className="container-fluid" style={{ marginTop: "4rem" }}>
          <div className="align-center-all full-height">
            <Card elevation={3} className="col-md-12 p-3">
              <CardContent>
                <div className={styles.header}>
                  <div
                    style={{
                      display: "flex",
                      gap: "1vw",
                      alignItems: "center",
                      // marginBottom:"2.25rem"
                    }}
                  >
                    <ArrowBackIosNewRounded
                      onClick={() => {
                        navigate("/dashboard");
                      }}
                      style={{ cursor: "pointer" }}
                    />
                    <h2 style={{ marginRight: "1rem",marginBottom:"0px" }} className="page-header">
                      Subscriptions
                    </h2>
                  </div>
                  <div className={styles.headerRight}>
                    <TablePagination
                      rowsPerPageOptions={[10, 20, 30]}
                      component="div"
                      count={filteredUsers.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                    <TextField
                      type="text"
                      placeholder="Search"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "transparent",
                          },
                          "&:hover fieldset": {
                            borderColor: "transparent",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "transparent",
                            boxShadow: "none",
                          },
                        },
                      }}
                      InputProps={{
                        style: {
                          height: "2.564vw",
                          boxShadow:
                            "0px 1.74px 3.48px 0px #0000001A inset, 0px -1.74px 3.8px 0px #C8C7C740 inset, 0px 1.74px 3.48px 0px #0000001A",
                        },
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton>
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>
                </div>
                <ToastContainer />
                <table className={styles.mainTable}>
                  <thead className={styles.tableHead}>
                    <tr>
                      <th style={{ textAlign: "center", width: "6.538vw" }}>
                        S. No.
                      </th>
                      <th style={{ width: "18.718vw", textAlign: "left" }}>
                        Name & Username
                      </th>
                      <th style={{ width: "20.513vw", textAlign: "left" }}>
                        Email
                      </th>
                      <th style={{ width: "20.513vw", textAlign: "left" }}>
                        Class
                      </th>
                      <th style={{ textAlign: "center", width: "15.641vw" }}>
                        Mobile
                      </th>
                      <th style={{ textAlign: "center" }}>Date & Time</th>
                      <th style={{ textAlign: "left", paddingLeft: "5.128vw" }}>
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {displayedUsers.map((user) => (
                      <tr key={user.user_id} className={styles.tableBody}>
                        <td style={{fontSize: "1.026vw"}}>{user.user_id}</td>
                        <td style={{ textAlign: "left", fontSize: "1.026vw" }}>
                          {user.name} <br />{" "}
                          <div style={{ fontSize: "0.897vw" }}>
                            {" "}
                            {user.username}{" "}
                          </div>
                        </td>
                        <td style={{ textAlign: "left", fontSize: "1.026vw" }}>
                          {user.email}
                        </td>
                        <td style={{ textAlign: "left", fontSize: "1.026vw" }}>{user.user_class || '-'}</td>
                        <td style={{ fontSize: "1.026vw" }}>{user.mobile}</td>
                        <td style={{ width: "8vw", fontSize: "1.026vw" }}>
                          {formatDate(user.created_at)}
                        </td>
                        <td style={{ paddingLeft: "5.128vw" }}>
                          <div className={styles.buttonContainer}>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={() =>
                                handleButtonClick(user.user_id, "specs")
                              }
                              style={{
                                height: "2.051vw",
                                color: "black",
                                backgroundColor: "#FFD6D2",
                                textTransform: "capitalize",
                                padding: "0.449vw 0.897vw",
                              }}
                              sx={{
                                fontSize: "0.897vw",
                              }}
                            >
                              Specialization
                            </Button>
                            <Button
                              variant="contained"
                              fullWidth
                              onClick={() =>
                                handleButtonClick(user.user_id, "skills")
                              }
                              style={{
                                backgroundColor: "#D1F4DE",
                                height: "2.051vw",
                                color: "black",
                                textTransform: "capitalize",
                                padding: "0.385vw 0.641vw",
                              }}
                              sx={{
                                fontSize: "0.897vw",
                              }}
                            >
                              Skills
                            </Button>
                            <Button
                              variant="contained"
                              color="error"
                              fullWidth
                              onClick={() =>
                                handleResetButtonClick(user.user_id)
                              }
                              style={{
                                height: "2.051vw",
                                color: "black",
                                backgroundColor: "#FCF6BC",
                                textTransform: "capitalize",
                                padding: "0.385vw 0.641vw",
                              }}
                              sx={{
                                fontSize: "0.897vw",
                              }}
                            >
                              Reset Limits
                            </Button>
                            {canUpdateUser && (
                              <Button
                                variant="contained"
                                fullWidth
                                onClick={() => {
                                  handleUpdate(user.user_id);
                                }}
                                style={{
                                  backgroundColor: "#CBEBF6",
                                  height: "2.051vw",
                                  color: "black",
                                  textTransform: "capitalize",
                                  padding: "0.385vw 0.641vw",
                                }}
                                sx={{
                                  fontSize: "0.897vw",
                                }}
                              >
                                Update
                              </Button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </tbody>
                  <Dialog
                    open={openDialog}
                    onClose={handleCloseDialog}
                    PaperProps={{
                      style: {
                        height: "auto",
                        padding: "1.5rem",
                        borderRadius: "0.513vw",
                        boxShadow:
                          "4px 4px 8px 0px #AEAEC099, box-shadow: -4px -4px 8px 0px #FFFFFF80",
                      },
                    }}
                  >
                    <DialogTitle
                      style={{
                        paddingLeft: "0",
                        fontWeight: "600",
                        paddingTop: "0",
                      }}
                    >
                      Student Skill Management
                    </DialogTitle>
                    <div className="dialog-content">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          marginBottom: "1.282vw",
                        }}
                      >
                        <div style={{ fontSize: "0.897vw", fontWeight: "500" }}>
                          Name: {selectedUser.name}
                        </div>
                        <div style={{ fontSize: "0.897vw", fontWeight: "500" }}>
                          Username: {selectedUser.username}
                        </div>
                      </div>
                      <table className="table">
                        <thead className={styles.dialogTableHead}>
                          <tr>
                            <th style={{ textAlign: "left" }}>Skill Name</th>
                            <th>Completion %</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredSkills.map((skill, index) => (
                            <tr key={skill.skill_id}>
                              <td style={{ textAlign: "left" }}>
                                {skill.skill_name}
                              </td>
                              <td>
                                <Typography style={{ fontSize: "0.8125rem" }}>
                                  {Math.floor(
                                    skillsCompletion.find(
                                      (completion) =>
                                        completion.skill_id === skill.skill_id
                                    )?.completion_percentage || 0
                                  )}
                                  %
                                </Typography>
                              </td>
                              <td>
                                <Switch
                                  value={skill.skill_id}
                                  onChange={(e) =>
                                    handleSkillToggle(e, skill.skill_id, index)
                                  }
                                  checked={selectedSkills[index]}
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    {actionType === "skills" && (
                      <div className={styles.buttonContainer}>
                        <Button
                          variant="outlined"
                          onClick={handleCloseDialog}
                          style={{
                            height: "2.564vw",
                            width: "15.385vw",
                            backgroundColor: "transparent",
                            color: "black",
                            textTransform: "capitalize",
                            border: "2px solid #313C63",
                            flex: "1",
                          }}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleSubscription}
                          style={{
                            height: "2.564vw",
                            width: "15.385vw",
                            backgroundColor: "#37446F",
                            textTransform: "capitalize",
                            flex: "1",
                          }}
                        >
                          Update Skills
                        </Button>
                      </div>
                    )}
                    {actionType === "update" && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={handleCloseDialog}
                          style={{
                            height: "2.564vw",
                            width: "15.385vw",
                            borderRadius: "4px",
                            textTransform: "capitalize",
                            border: "2px solid #313C63",
                            color: "#000000",
                          }}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleUnsubscription}
                          style={{
                            height: "2.564vw",
                            width: "15.385vw",
                            borderRadius: "4px",
                            textTransform: "capitalize",
                            color: "#ffffff",
                            backgroundColor: "#37446F",
                          }}
                        >
                          Unsubscribe
                        </Button>
                      </div>
                    )}
                  </Dialog>
                  <Dialog
                    open={openSpecDialog}
                    onClose={handleCloseDialog}
                    PaperProps={{
                      style: {
                        width: "35.128vw",
                        padding: "1.5rem",
                        borderRadius: "0.513vw",
                        boxShadow:
                          "4px 4px 8px 0px #AEAEC099, box-shadow: -4px -4px 8px 0px #FFFFFF80",
                      },
                    }}
                  >
                    <DialogTitle
                      style={{
                        paddingLeft: "0",
                        fontWeight: "600",
                        paddingTop: "0",
                      }}
                    >
                      Add Specialization
                    </DialogTitle>
                    <div className="dialog-content">
                      
          <div style={{ display: "flex", gap: "1rem", marginBottom: "1rem" }}>
            <FormControl size="small" fullWidth>
              <InputLabel id="duration-label">Access Duration (days)</InputLabel>
              <Select
                labelId="duration-label"
                label="Access Duration (days)"
                value={selectedDays}
                onChange={(e) => setSelectedDays(Number(e.target.value))}
              >
                {[1, 3, 7, 15, 30, 90, 365].map((d) => (
                  <MenuItem key={d} value={d}>{d}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <TextField
            label="Search specializations"
            value={specSearchQuery}
            onChange={(e) => setSpecSearchQuery(e.target.value)}
            size="small"
            fullWidth
            className="customTextfield"
            sx={{
              marginBottom: "1rem",
              width: "100% !important",
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "transparent",
                },
                "&:hover fieldset": {
                  borderColor: "transparent",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "transparent",
                },
              },
            }}
          />
<table className="table">
                        <thead className={styles.dialogTableHead}>
                          <tr>
                            <th style={{ textAlign: "left" }}>
                              Specialization Name
                            </th>
                            {/* <th>Completion %</th> */}
                            <th>Toggle</th>
                            <th>Edit Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {specLoading ? (
                            <tr>
                              <td colSpan="3" style={{ textAlign: "center" }}>
                                Loading...
                              </td>
                            </tr>
                          ) : specError ? (
                            <tr>
                              <td colSpan="3" style={{ textAlign: "center" }}>
                                {specError}
                              </td>
                            </tr>
                          ) : filteredSpecs.length === 0 ? (
                            <tr>
                              <td colSpan="3" style={{ textAlign: "center" }}>
                                No specializations found
                              </td>
                            </tr>
                          ) : (
                            filteredSpecs.map((spec, index) => (
                              <tr key={spec.specialization_id}>
                                <td style={{ textAlign: "left", verticalAlign: "middle" }}>
                                  {spec.specialization_name}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  <Switch
                                    value={spec.specialization_id}
                                    onChange={(e) =>
                                      handleSpecToggle(
                                        e,
                                        spec.specialization_id,
                                        index
                                      )
                                    }
                                    checked={selectedSpecs[index]}
                                  />
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  <Button
                                    variant="contained"
                                    onClick={() =>
                                      handleOpenEditDate(spec.specialization_id)
                                    }
                                    style={{
                                      textTransform: "capitalize",
                                      minWidth: "unset",
                                      padding: "0.25rem 0.6rem",
                                      borderRadius: "4px",
                                      backgroundColor: "#37446F",
                                      color: "#ffffff",
                                    }}
                                  >
                                    Edit Date
                                  </Button>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                    {actionType === "specs" && (
                      <div className={styles.buttonContainer}>
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={handleCloseDialog}
                          style={{
                            height: "2.564vw",
                            width: "15.385vw",
                            borderRadius: "4px",
                            textTransform: "capitalize",
                            border: "2px solid #313C63",
                            color: "#000000",
                          }}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="contained"
                          onClick={handleSpecSubscription}
                          style={{
                            height: "2.564vw",
                            backgroundColor: "#37446F",
                            textTransform: "capitalize",
                            width: "-webkit-fill-available",
                          }}
                        >
                          Update Specialization
                        </Button>
                      </div>
                    )}
                  </Dialog>
                  <Dialog
                    open={openEditDateDialog}
                    onClose={handleCloseEditDate}
                    PaperProps={{
                      style: {
                        width: "30vw",
                        padding: "1.25rem",
                        borderRadius: "0.513vw",
                      },
                    }}
                  >
                    <DialogTitle
                      style={{
                        paddingLeft: "0",
                        fontWeight: "600",
                        paddingTop: "0",
                      }}
                    >
                      Edit End Date
                    </DialogTitle>
                    <div
                      style={{
                        fontSize: "0.9rem",
                        color: "#4D4D4D",
                        marginBottom: "0.75rem",
                      }}
                    >
                      Current Expiry:{" "}
                      {formatSkillEndDate(
                        filteredSpecs.find(
                          (spec) => spec.specialization_id === editTargetSpecId
                        )?.skillEndDate
                      )}
                    </div>
                    <div
                      style={{ display: "flex", gap: "0.5rem", marginBottom: "1rem" }}
                    >
                      <Button
                        variant={editMode === "ADD_DAYS" ? "contained" : "outlined"}
                        onClick={() => setEditMode("ADD_DAYS")}
                        style={{ textTransform: "capitalize", flex: 1 }}
                      >
                        Add Days
                      </Button>
                      <Button
                        variant={editMode === "SET_DATE" ? "contained" : "outlined"}
                        onClick={() => setEditMode("SET_DATE")}
                        style={{ textTransform: "capitalize", flex: 1 }}
                      >
                        Pick Date
                      </Button>
                    </div>
                    {editMode === "ADD_DAYS" ? (
                      <TextField
                        fullWidth
                        type="number"
                        label="Days"
                        value={editDays}
                        onChange={(e) => setEditDays(e.target.value)}
                        inputProps={{ min: 1, step: 1 }}
                      />
                    ) : (
                      <TextField
                        fullWidth
                        type="date"
                        label="Target Date"
                        value={editTargetDate}
                        onChange={(e) => setEditTargetDate(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                    <div className={styles.buttonContainer} style={{ marginTop: "1rem" }}>
                      <Button
                        variant="outlined"
                        onClick={handleCloseEditDate}
                        style={{
                          textTransform: "capitalize",
                          border: "2px solid #313C63",
                          color: "#000000",
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="contained"
                        onClick={handleUpdateSubscriptionEndDate}
                        style={{
                          backgroundColor: "#37446F",
                          textTransform: "capitalize",
                        }}
                      >
                        Update Date
                      </Button>
                    </div>
                  </Dialog>
                  <Dialog open={updateDialog} onClose={handleUpdateDialogClose}>
                    <DialogTitle style={{ fontWeight: "700" }}>
                      Update User Details
                    </DialogTitle>
                    <form
                      className="m-4"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "0.5rem",
                      }}
                    >
                      <TextField
                        className={styles.customTextfield}
                        type="text"
                        label="Name"
                        name="name"
                        variant="outlined"
                        value={formValues.name}
                        onChange={handleFormChange}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              borderColor: "transparent",
                            },
                            "&:hover fieldset": {
                              borderColor: "transparent",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "transparent",
                            },
                          },
                          mb: "1rem",
                        }}
                      />
                      <TextField
                        className={styles.customTextfield}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              borderColor: "transparent",
                            },
                            "&:hover fieldset": {
                              borderColor: "transparent",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "transparent",
                            },
                          },
                          mb: "1rem",
                        }}
                        type="text"
                        label="Email"
                        name="email"
                        variant="outlined"
                        value={formValues.email}
                        onChange={handleFormChange}
                      />
                      <TextField
                        className={styles.customTextfield}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              borderColor: "transparent",
                            },
                            "&:hover fieldset": {
                              borderColor: "transparent",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "transparent",
                            },
                          },
                          mb: "1rem",
                        }}
                        type="text"
                        label="mobile"
                        name="mobile"
                        variant="outlined"
                        value={formValues.mobile}
                        onChange={handleFormChange}
                      />
                       <TextField
                    className={styles.customTextfield}
                    type="text"
                    label="Referral Code"
                    name="referredBy"
                    variant="outlined"
                    value={formValues.referredBy}
                    onChange={handleFormChange}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                              borderColor: 'transparent',
                          },
                          '&:hover fieldset': {
                              borderColor: 'transparent',
                          },
                          '&.Mui-focused fieldset': {
                              borderColor: 'transparent',
                          },
                      },
                      mb: '1rem'
                  }}
                  />
                      <FormControl
                        className={styles.customTextfield}
                        variant="outlined"
                        sx={{ mb: "1rem" }}
                      >
                        <InputLabel>Subscription Type</InputLabel>
                        <Select
                          name="subscription_type"
                          value={formValues.subscription_type}
                          onChange={handleFormChange}
                          label="Subscription Type"
                        >
                          <MenuItem value="free">Free</MenuItem>
                          <MenuItem value="paid">Paid</MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl
                        className={styles.customTextfield}
                        variant="outlined"
                        sx={{ mb: "1rem" }}
                      >
                        <InputLabel>Communication Language</InputLabel>
                        <Select
                          name="communicationLanguage"
                          value={formValues.communicationLanguage}
                          onChange={handleFormChange}
                          label="Communication Language"
                        >
                          <MenuItem value="hi">Hindi</MenuItem>
                          <MenuItem value="en">English</MenuItem>
                        </Select>
                      </FormControl>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.5rem",
                        }}
                      >
                        <Button
                          onClick={handleUpdateDialogClose}
                          className="outlined-button"
                          style={{ flex: "1" }}
                        >
                          Cancel
                        </Button>
                        {canUpdateUser && (
                          <Button
                            style={{ flex: "1" }}
                            className="filled-button"
                            onClick={() => {
                              handleUpdateUser(formValues.id);
                            }}
                          >
                            Update
                          </Button>
                        )}
                      </div>
                    </form>
                  </Dialog>
                </table>
              </CardContent>
            </Card>
          </div>
        </div>
      ) : (
        <SubscriptionsMobile />
      )}
    </>
  );
};

export default Subscriptions;
